import { Navigate, useLocation } from "react-router-dom";
import { getDefaultLocale } from "@/i18n";

export function RootRedirect() {
  const { search, hash } = useLocation();
  const locale = getDefaultLocale();

  return (
    <Navigate
      to={{ pathname: `/${locale}`, search, hash }}
      replace
    />
  );
}
